import React, { useEffect, useState } from 'react';

import CardContainer from './components/CardContainer';
import OrderItemsTable from './components/OrderItemsTable';
import 'antd/dist/antd.min.css';
import './css/header.css';
import './css/global.css';
import Header from './components/Header';
import Footer from './components/Footer';

import './i18next/i18next.js';
import { useTranslation } from 'react-i18next';
import { Spin } from 'antd';
import ErrorMsg from './components/ErrorMsg.js';
import { spinnerStyle } from './utils/utils.js';


function App() {
  const [orderData, setOrderData] = useState(null);

  const [isLoading, setIsLoading] = useState(true);

  const [isError, setIsError] = useState(false);
  const [errorDetails, setErrorDetails] = useState({ errorType: "500" });

  const [salesOrg, setSalesOrg] = useState();




  // const salesorg = context && context?.orderData && context?.orderData?.orderDetails?.orderInfo?.salesorg
const params = new URLSearchParams(window.location.search);
const newParams = new URLSearchParams(
  Array.from(params, ([key, value]) => [key.toLowerCase(), value])
);
console.log("newParams", newParams.get('guid'), newParams.get('st'));
  const getDataFromAPI = async () => {

    const guid = newParams.get('guid');
    const st = newParams.get('st');
    
    const URL = process.env.REACT_APP_Guid_Api + guid + "&st=" + st;


    await fetch(URL, {
      method: 'GET',
      header: {
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        return response.json()
      })
      .then((data) => {
        if (data) {
          if (data?.SUCCESS) {
            setOrderData(data?.orderDetails);

            setSalesOrg(data?.orderDetails?.orderInfo?.salesorg);
          }
          else {
            setIsError(true);

            setErrorDetails({ errorType: "warning", errorName: data?.ERRMSG });
          }
        }
        else {
          setIsError(true);

          setErrorDetails({ errorType: "500" });
        }
      })
      .catch((error) => {
        console.log("error in API Call: ", error);

        setIsError(true);

        setErrorDetails({ errorType: "500" });
      });


    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }



  useEffect(() => {
    getDataFromAPI();
  }, []);



  const countryJson = JSON.parse(process.env.REACT_APP_Country)

  const headerCountry = countryJson[salesOrg?.toUpperCase()] || 'global';

  const { t, i18n } = useTranslation();
  

  // const cl = new URLSearchParams(window.location.search).get('cl')?.toLocaleLowerCase()
  const cl = newParams.get('cl')?.toLocaleLowerCase();
  console.log("cl", cl);

  useEffect(() => {
    i18n.changeLanguage(cl || "en");
  }, [cl])




  return (
    <div >
      <Header
        country={headerCountry}
        language={cl || "en"}
      />

      {
        isLoading && <Spin style={spinnerStyle} />
      }
      {
        !isLoading && !isError && orderData &&
        <>
          <CardContainer orderData={orderData} />
          <OrderItemsTable orderData={orderData} />
        </>
      }
      {
        !isLoading && isError && <ErrorMsg errorDetails={errorDetails} />
      }


      <Footer
        country={headerCountry}
        language={cl || "en"}
      />

    </div>
  );
}

export default App;
